// Existing session storage is the source; current /auth/me owns user/role data.
// Tokens are private comparison values, never returned, logged or used as keys.
export function createAuthSessionReconciler({readToken, subscribe, readMe, clearToken, extractUser, onState}) {
  let generation = 0, disposed = false, started = false, observedToken, unsubscribe = null
  async function refresh() {
    if (disposed) return
    const token = readToken() || null
    if (started && token === observedToken) return
    started = true; observedToken = token
    const current = ++generation
    onState({user: null, status: token ? 'loading' : 'anon'})
    if (!token) return
    const active = () => !disposed && current === generation && (readToken() || null) === token
    try {
      const response = await readMe()
      if (!active()) return
      onState({user: extractUser(response) || {username: 'representative'}, status: 'authed'})
    } catch {
      if (!active()) return
      clearToken(); observedToken = null
      onState({user: null, status: 'anon'})
    }
  }
  return {
    start() {if (disposed || unsubscribe) return; unsubscribe = subscribe(() => {void refresh()}); void refresh()},
    refresh,
    dispose() {disposed = true; generation++; unsubscribe?.(); unsubscribe = null; observedToken = null},
  }
}
